"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresentationSubmissionVB = void 0;
const jsonpath_1 = __importDefault(require("jsonpath"));
const ConstraintUtils_1 = require("../../ConstraintUtils");
const validationBundler_1 = require("./validationBundler");
class PresentationSubmissionVB extends validationBundler_1.ValidationBundler {
    constructor(parentTag) {
        super(parentTag, 'presentation_submission');
    }
    getValidations(ps) {
        return [
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => ps != null,
                message: 'presentation_submission should be non null.',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.nonEmptyString(ps === null || ps === void 0 ? void 0 : ps.id),
                message: 'id should not be empty',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.nonEmptyString(ps === null || ps === void 0 ? void 0 : ps.definition_id),
                message: 'presentation_definition_id should not be empty',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.descriptorMapMustBePresent(ps === null || ps === void 0 ? void 0 : ps.descriptor_map),
                message: 'descriptor_map should be a non-empty list',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.idMustBeSameForEachLevelOfNesting(ps === null || ps === void 0 ? void 0 : ps.descriptor_map),
                message: 'each descriptor should have a one id in it, on all levels',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.formatsShouldBeKnown(ps === null || ps === void 0 ? void 0 : ps.descriptor_map),
                message: 'each format should be one of the known format',
            },
            {
                tag: this.getTag(),
                target: ps,
                predicate: (ps) => PresentationSubmissionVB.pathsShouldBeValidJsonPaths(ps === null || ps === void 0 ? void 0 : ps.descriptor_map),
                message: 'each path should be a valid jsonPath',
            },
        ];
    }
    static nonEmptyString(id) {
        // TODO extract to generic utils or use something like lodash
        return id != null && id.length > 0;
    }
    static descriptorMapMustBePresent(descriptor_map) {
        return descriptor_map != null && descriptor_map.length > 0;
    }
    static idMustBeSameForEachLevelOfNesting(descriptor_map) {
        let doesEachDescriptorHasOneIdOnAllLevelsOfNesting = true;
        if (descriptor_map != null) {
            for (let i = 0; i < descriptor_map.length; i++) {
                doesEachDescriptorHasOneIdOnAllLevelsOfNesting =
                    doesEachDescriptorHasOneIdOnAllLevelsOfNesting &&
                        PresentationSubmissionVB.isIdSameForEachLevelOfNesting(descriptor_map[i], descriptor_map[i].id);
            }
        }
        return doesEachDescriptorHasOneIdOnAllLevelsOfNesting;
    }
    static isIdSameForEachLevelOfNesting(descriptor, id) {
        let isSame = true;
        if (descriptor != null && descriptor.path_nested != null) {
            if (descriptor.path_nested.id == id) {
                // WARNING : Specification does not allow any bounds. So, no checks against stackoverflow due to unbounded recursion.
                isSame = isSame && PresentationSubmissionVB.isIdSameForEachLevelOfNesting(descriptor.path_nested, id);
            }
            else {
                isSame = false;
            }
        }
        return isSame;
    }
    static formatsShouldBeKnown(descriptor_map) {
        let isProofFormatKnown = true;
        if (descriptor_map != null) {
            const formats = ['jwt', 'jwt_vc', 'jwt_vp', 'ldp', 'ldp_vc', 'ldp_vp'];
            for (let i = 0; i < descriptor_map.length; i++) {
                isProofFormatKnown = PresentationSubmissionVB.formatShouldBeKnown(descriptor_map[i], formats);
            }
        }
        return isProofFormatKnown;
    }
    static formatShouldBeKnown(descriptor, formats) {
        let isProofFormatKnown = true;
        if (descriptor != null) {
            isProofFormatKnown = formats.includes(descriptor.format);
        }
        if (descriptor.path_nested != null) {
            // WARNING : Specification does not allow any bounds. So, no checks against stackoverflow due to unbounded recursion.
            isProofFormatKnown =
                isProofFormatKnown && PresentationSubmissionVB.formatShouldBeKnown(descriptor.path_nested, formats);
        }
        return isProofFormatKnown;
    }
    static pathsShouldBeValidJsonPaths(descriptor_map) {
        let isPathValidJsonPath = true;
        if (descriptor_map != null) {
            for (let i = 0; i < descriptor_map.length; i++) {
                isPathValidJsonPath = PresentationSubmissionVB.pathShouldBeValid(descriptor_map[i], []);
            }
        }
        return isPathValidJsonPath;
    }
    static pathShouldBeValid(descriptor, invalidPaths) {
        if (descriptor != null) {
            try {
                jsonpath_1.default.parse(descriptor.path);
            }
            catch (err) {
                invalidPaths.push(descriptor.path);
            }
            if (descriptor.path_nested != null) {
                // WARNING : Specification does not allow any bounds. So, no checks against stackoverflow due to unbounded recursion.
                PresentationSubmissionVB.pathShouldBeValid(descriptor.path_nested, invalidPaths);
            }
        }
        if (invalidPaths.length > 0) {
            throw new ConstraintUtils_1.Checked('', ConstraintUtils_1.Status.ERROR, 'These were not parsable json paths: ' + JSON.stringify(invalidPaths));
        }
        return true;
    }
}
exports.PresentationSubmissionVB = PresentationSubmissionVB;
